export enum AddonApplyType {
  InOrder = 'inOrder',
  Basic = 'basic',
}
